import { WorkspaceNewSignUpFormRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// Static, so it wins over the sibling `sign-up-forms_/$id` route for `/new`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/sign-up-forms_/new')({
  component: WorkspaceNewSignUpFormRoute,
});
